<script lang="ts" setup>
const props = defineProps<{
  store: SFCCStore
  index: number
  selectedStore: SFCCStore | undefined
  openAccordionIndex?: number
}>()
const emit = defineEmits<{
  (e: 'select-store', store: SFCCStore): void
  (e: 'toggle', isOpen: boolean): void
}>()
const { locale } = useI18n()
const shopStore = useShopStore()
const group = 'store locator'

const storeUrl = getStoreUrl(props.store, locale.value === 'fr' ? '/fr/stores' : '/stores')

const storeAccordionDataLayer: Omit<DataLayerObject, 'eventName' | 'event'> = {
  group,
  search: {
    term: shopStore.searchTerm || '',
  },
  store: {
    id: props.store.id,
    name: props.store.name,
    postcode: props.store.postalCode,
    suburb: props.store.city,
  },
  info: {
    location: 'store locator',
    position: props.index + 1,
    count: shopStore.storesList.length,
  },
  data: undefined,
}

function sendDatalayerLinkClickEvent(linkDetails: { label: string; url?: string }) {
  handleResultClickDataLayer({
    storeResults: shopStore.storesList,
    searchValue: shopStore.searchTerm || '',
    storeIndex: props.index,
    linkDetails,
    locale: locale.value,
    group,
  })
}
</script>
<template>
  <div
    class="store-selection"
    :class="{ 'store-selection--selected': selectedStore?.id === props.store.id }"
    @click.passive="emit('select-store', props.store)"
    role="button"
    tabindex="0"
  >
    <div class="store-selection__header">
      <div class="store-selection__header-top">
        <p>Michael Hill</p>
        <Anchor
          variant="text"
          :url="storeUrl"
          @click.stop="sendDatalayerLinkClickEvent({ label: 'store link', url: storeUrl })"
          >{{ $t('store_page.more_details_link') }}</Anchor
        >
      </div>
      <div class="store-selection__name">
        <h3>{{ index + 1 }}. {{ tidyStoreName(store.name) }}</h3>
        <StoreAddress :store="store" :position="index + 1" @datalayer-click="sendDatalayerLinkClickEvent" />
      </div>
    </div>
    <StoreHours
      :store="store"
      :position="index + 1"
      :is-accordion="true"
      :is-accordion-open="openAccordionIndex === index"
      :ga-options="storeAccordionDataLayer"
      @toggle="emit('toggle', $event)"
    />
    <StoreLinks :position="index + 1" :store="store" @datalayer-click="sendDatalayerLinkClickEvent" />
  </div>
</template>

<style lang="postcss">
.store-selection {
  display: flex;
  padding: var(--space-60) var(--space-50);
  flex-direction: column;
  justify-content: center;
  gap: var(--space-50);
  border-radius: var(--space-20);
  border: 1px solid var(--border-disabled, #010101);
  background: var(--surface-light-00, #fff);
  cursor: pointer;

  &.store-selection--selected {
    border: 1px solid var(--border-dark-10, #010101);
    box-shadow:
      0 10px 16px -4px rgba(0, 0, 0, 0.1),
      0 4px 6px -4px rgba(0, 0, 0, 0.1);
  }

  .store-selection__header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--space-20);
    p {
      margin-bottom: 0;
    }
  }

  .store-selection__name {
    display: flex;
    flex-direction: column;
    gap: var(--space-30);
    h3 {
      margin-bottom: 0;
    }
    .store-address__phone {
      margin-top: 0;
    }
  }
}
</style>
